module.exports = __webpack_public_path__ + "img/img8.b44f5d34.png";